import { WINDOW_BY_ID, WINDOW_IDS } from "../../data/windows";
import { useWindowManager } from "../../context/WindowContext";
import { Window } from "../Window/Window";
import chrome from "../Bio/Bio.module.css";
import classes from "./Notice.module.css";

const styles = { ...chrome, ...classes };
const meta = WINDOW_BY_ID[WINDOW_IDS.NOTICE];

export const Notice = () => {
  const { close } = useWindowManager();

  return (
    <Window id={WINDOW_IDS.NOTICE} classes={styles}>
      <div className={classes.body}>
        <div className={classes.message}>
          <img
            src={meta.icon}
            alt={meta.iconAlt}
            className={classes.infoIcon}
            draggable={false}
          />
          <div className={classes.text}>
            <p>This site is best viewed on a desktop.</p>
            <p>For the full experience, please open it from a computer.</p>
          </div>
        </div>
        <button
          type="button"
          className={classes.ok}
          onClick={() => close(WINDOW_IDS.NOTICE)}
        >
          OK
        </button>
      </div>
    </Window>
  );
};
